// extracted by mini-css-extract-plugin
var _1 = "fEPB8HF0OB2WeYC6eIqy";
var _2 = "whYLwkG3c6QoxfBS4_q0";
export { _1 as "footer", _2 as "navItem" }
